import React from "react";
import PropTypes from 'prop-types';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class ImageSlider extends React.Component {
  static propTypes = {
    images: PropTypes.array.isRequired,
  };

  render() {
    var settings = {
      dots: true,
      adaptiveHeight: true,
      className: 'mb-2',
    };

    return (
      <Slider {...settings}>
        {this.props.images.map(image=> <div key={`image-${image.id}`}>
          <img src={image.url} data-id={image.id}/>
        </div>)}
      </Slider>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// app/client/bundles/EmailCampaign/ImageSlider.js